
<template>
  <div class="aco-info-box">
    <div class="aco-details">
      <h5>{{ $t('email') }}</h5>
      <b-container fluid>
        <b-row>
          <b-col cols="12" md="8" lg="6">
            <b-form class="mt-4" @submit.prevent="sendEmail" @reset="resetForm">
              <fieldset :disabled="loading">
                <b-row class="aco-details-row align-items-center">
                  <b-col cols="4" class="text-left">
                    <label>{{ $t('emailClient') }}</label>
                  </b-col>
                  <b-col class="text-left">
                    <b-form-select id="emailClient" v-model="clientId" :options="clientIds" required>
                    </b-form-select>
                  </b-col>
                </b-row>
                <b-row class="aco-details-row align-items-center">
                  <b-col cols="4" class="text-left">
                    <label>{{ $t('emailType') }}</label>
                  </b-col>
                  <b-col class="text-left">
                    <b-form-select id="emailType" v-model="emailType" :options="emailTypes" required>
                    </b-form-select>
                  </b-col>
                </b-row>
                <b-row class="aco-details-row align-items-center">
                  <b-col cols="4" class="text-left">
                    <label>{{ $t('emailAddress') }}</label>
                  </b-col>
                  <b-col class="text-left">
                    <b-form-input id="emailId" type="email" v-model="emailId" v-on:keyup="onKeyup" :state="emailState" autofocus required />
                  </b-col>
                </b-row>
                <b-row class="aco-details-row">
                  <b-col class="text-left">
                    <b-button type="submit" variant="primary" :disabled="!emailState">{{ $t('sendEmail') }}</b-button>
                  </b-col>
                </b-row>
              </fieldset>
            </b-form>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>
<script>
  import MailService from '../../services/MailService'

  export default {
    name: 'Mail',
    data () {
      return {
        loading: false,
        emailType: 'EXPIRATION_MAIL',
        emailId: '',
        clientId: 'aunivers_client',
      }
    },
    computed: {
      emailTypes () {
        return [
          { value: 'EXPIRATION_MAIL', text: this.$t('expirationMail') },
          { value: 'PASSWORD_RESET', text: this.$t('passwordReset') },
          { value: 'USER_ACTIVATION', text: this.$t('userActivation') },
          { value: 'USER_INVITE', text: this.$t('userInvite') },
        ]
      },
      emailState () {
        let emailId = this.emailId
        return emailId && emailId.includes('@')
      },
      clientIds() {
        return [
          'aunivers_client',
          'kunne_client',
          'vgs_client',
          'juridika_client',
        ]
      }
    },
    methods: {
      onKeyup (event) {
        if (event.which === 13) {
          if(!this.emailState){
            return
          }
          this.sendEmail()
        }
      },
      async sendEmail () {
        this.loading = true
        try {
          await MailService.sendMail(this.emailType, this.emailId, this.clientId)
          this.showToastSuccess()
        } catch(error) {
          let errorMessage = error?.message ?? 'Error occurred while sending ' + this.emailType + ' to emailId ' + this.emailId
          this.showToastError(errorMessage)
          throw error
        } finally {
          this.loading = false
        }
      },
      resetForm () {
        this.emailId = ''
      },
      showToastError (error) {
        this.$bvToast.toast(error, {
          title: this.$t('errorOccurred'),
          toaster: 'b-toaster-top-center',
          variant: 'danger',
          autoHideDelay: 5000
        })
      },
      showToastSuccess () {
        this.$bvToast.toast(this.$t('emailSuccess'), {
          title: this.$t('success'),
          toaster: 'b-toaster-top-center',
          variant: 'success',
          autoHideDelay: 5000
        })
      }
    },
    i18n: {
      messages: {
        en: {
          'emailAddress': 'Email address',
          'emailType': 'Email type',
          'expirationMail': 'User expiry warning',
          'passwordReset': 'Password reset mail',
          'userActivation': 'Activate user',
          'emailClient': 'Client ID',
          'sendEmail': 'Send email',
          'emailSuccess': 'Email sent successfully',
          'userInvite': 'Invite user',
        },
        nb: {
          'emailAddress': 'Epostadresse',
          'emailType': 'Eposttype',
          'expirationMail': 'Varsel om sletting av bruker',
          'passwordReset': 'Resett av passord',
          'userActivation': 'Aktivering av bruker',
          'emailClient': 'Client ID',
          'sendEmail': 'Send epost',
          'emailSuccess': 'Epost sendt',
          'userInvite': 'Invitere bruker',
        }
      }
    }
  }
</script>
